

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ACCEPTAPPRAISALREAPPLY= createAsyncThunk(
  "acceptAppraisalReapply/acceptAppraisalReapply",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const acceptAppraisalReapplySlice = createSlice({
  name: "acceptAppraisalReapplySlice",
  initialState: {
    acceptAppraisalReapply: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfacceptAppraisalReapply: (state) => {
        state.acceptAppraisalReapply.loading = false
        state.acceptAppraisalReapply.error = false
        state.acceptAppraisalReapply.data = []
        state.acceptAppraisalReapply.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ACCEPTAPPRAISALREAPPLY.fulfilled, (state, action) => {
      state.acceptAppraisalReapply = {
        ...state.acceptAppraisalReapply,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ACCEPTAPPRAISALREAPPLY.pending, (state, action) => {
      state.acceptAppraisalReapply = {
        ...state.acceptAppraisalReapply,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ACCEPTAPPRAISALREAPPLY.rejected, (state, action) => {
      state.acceptAppraisalReapply = {
        ...state.acceptAppraisalReapply,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const acceptAppraisalReapplyAction = {
    ACCEPTAPPRAISALREAPPLY,
};

export { acceptAppraisalReapplyAction };
export default acceptAppraisalReapplySlice.reducer;
export const {setInitialStateOfacceptAppraisalReapply} = acceptAppraisalReapplySlice.actions
